/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Color_BrownInputs */

const en_booking_color_brown = /** @type {(inputs: Booking_Color_BrownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brown`)
};

const pl_booking_color_brown = /** @type {(inputs: Booking_Color_BrownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brązowy`)
};

/**
* | output |
* | --- |
* | "Brown" |
*
* @param {Booking_Color_BrownInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_color_brown = /** @type {((inputs?: Booking_Color_BrownInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Color_BrownInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_color_brown(inputs)
	return en_booking_color_brown(inputs)
});